import React from 'react';
import { Route, Link } from 'react-router-dom';

class SidebarNavList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            active: -1,
            clicked: -1,
        };
        //console.log(this.state);
    }

    handleExpand(e, i, match) {
        e.preventDefault();
        this.setState({
            active: (this.state.active === i ? -1 : i),
            clicked: 1
        });
    }

    onClick(e, i, match) {
        e.preventDefault();
        
        this.setState({
            active: (this.state.active === i ? -1 : i),
            clicked: 1
        });
        //console.log(this.state.active + " : " + this.state.clicked);
    }

    render() {
        var icon = this.props.data.icon && <i className={this.props.data.icon}></i>;
        var img = this.props.data.img && <div className="icon-img"><img src={this.props.data.img} alt="" /></div>;
        var caret = (this.props.data.children && !this.props.data.badge) && <b className="caret"></b>;
        var label = this.props.data.label && <span className="label label-theme m-l-5">{this.props.data.label}</span>;
        var badge = this.props.data.badge && <span className="badge pull-right">{this.props.data.badge}</span>;
        var title = this.props.data.title && <span className="g-font-size-13">{this.props.data.title} {label}</span>;

        //console.log(this.state);
        //console.log(this.handleExpand);

        // https://stackoverflow.com/questions/37949981/call-child-method-from-parent

        return (
            <Route path={this.props.data.path} exact={this.props.data.exact} children={({ match }) => (
                <li className={(match ? "active " : "") + ((this.props.active || (this.props.clicked === -1 && match)) ? 'expand ' : 'closed ') + (this.props.data.children ? "has-sub " : "")}>
                    {
                        //console.log(match)
                        //console.log(this.state.active)
                    }
                    {this.props.data.children
                        ? <Link to={this.props.data.path} onClick={this.props.expand}>{img} {icon} {badge} {title} {caret}</Link>
                        : <Link to={this.props.data.path}>{img} {icon} {badge} {title} {caret}</Link>
                    }
                    {this.props.data.children && (

                        <ul className={"sub-menu "}>
                            {this.props.data.children && this.props.data.children.map((submenu, i) => (
                                <SidebarNavList
                                    data={submenu}
                                    key={i}
                                    expand={(e) => this.handleExpand(e, i, match)}
                                    active={i === this.state.active}
                                    clicked={this.state.clicked}
                                />
                            ))}
                        </ul>
                    )}
                </li>
            )} />

        )
    }
}

export default SidebarNavList;


// WEBPACK FOOTER //
// ./src/components/admin/sidebar/sidebar-nav-list.js